import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { AutomationTypes } from '@tokeet-frontend/automations'

@Component({
  selector: 'app-automation-wizard-left',
  templateUrl: './automation-wizard-left.component.html',
  styleUrls: ['./automation-wizard-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AutomationWizardLeftComponent implements OnInit {
  @Input() type: AutomationTypes
  @Input() image: string

  @Output() typeChange = new EventEmitter<AutomationTypes>()

  constructor() {}

  ngOnInit(): void {}

  onTypeChange(type: AutomationTypes) {
    this.typeChange.emit(type)
  }
}
